import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Observable, ReplaySubject, Subject, combineLatest, of } from "rxjs";
import { animate, state, style, transition, trigger } from '@angular/animations';
import { catchError, tap } from 'rxjs/operators';

import { Course } from 'lms-api';
import { CourseNotFoundException } from 'lms-api';
import { TitleWrapperService } from '../_services/title-wrapper.service';
import { UserCourseDataService } from 'lms-api';

@Component({
  selector: 'app-course-view',
  templateUrl: './course-view.component.html',
  styleUrls: ['./course-view.component.scss'],
  animations: [
    trigger('biggifyImage', [
      state('big', style({
        width: '74%'
      })),
      state('little', style({
        width: '25%'
      })),
      transition('little <=> big', animate('500ms ease-in-out'))
    ])
  ]
})
export class CourseViewComponent implements OnInit {
  public courseLoadStatus: 'Loading' | 'NotFound' | 'NoAccess' | 'Archived' | 'Loaded' = 'Loading';
  private courseSetIDUID: string;
  private lastCourseAlias: string;
  public stableCourse$: ReplaySubject<Course> = new ReplaySubject<Course>(1);
  public dynamicCourse$: ReplaySubject<Course> = new ReplaySubject<Course>(1);
  public certificateLink;
  public pendingStatusChange: boolean = false;
  public authorContent$: ReplaySubject<string> = new ReplaySubject<string>(1);

  bigImage: string = 'little';

  constructor(
    public ucdService: UserCourseDataService,
    private route: ActivatedRoute,
    private router: Router,
    private titleService: TitleWrapperService) {

      if(window.innerWidth < 768) {
        this.bigImage = "smalldevice";
      }

    combineLatest([this.route.paramMap, this.ucdService.User]).subscribe(
      ([params, user]) => {
        if (this.lastCourseAlias != params.get('alias')) {
          this.lastCourseAlias = params.get('alias');
          this.courseLoadStatus = "Loading";
        }
        this.ucdService.GetCourse(params.get('alias')).pipe(
          catchError(err => {
            if (err instanceof CourseNotFoundException) {
              this.courseLoadStatus = 'NotFound';
              return of(new Course());
            }
          }),
          tap(course => {
            if (!course.nid) return;
            if (!course || !course.canAccess) {
              this.courseLoadStatus = 'NoAccess';
            }
            if (course.archived_course) {
              this.courseLoadStatus = 'Archived';
            }

            if (this.courseLoadStatus == 'Loading') {
              this.dynamicCourse$.next(course);
              let courseUid = course.netforum_course_id + user.ID;
              if ((!course.rights.includes('viewcontent')) || this.courseSetIDUID != courseUid) {
                this.courseSetIDUID = course.netforum_course_id + user.ID;
                this.stableCourse$.next(course);
              }
              this.certificateLink = this.ucdService.GetCertificateURL(course);

              this.courseLoadStatus = 'Loaded';
            }
          })
        ).subscribe();
      }
    );
  }

  ngOnInit() {
  }

  updatePendingStatusChange(pendingChange) {
    this.pendingStatusChange = pendingChange;
  }

  GetTheZoomies() {
    this.bigImage = 'big';
  }
}
